

































































































































import PageHeader from "@/components/PageHeader.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, State, Getter } from "vuex-class";
import moment from "moment";
import { duration } from "@/helpers";
import { capitalize } from "lodash";
import * as api from "@/lib/api";
import { User } from "@/types";
import { getUserId } from "@/helpers";
import { collections } from "@/configs/firebase";
import logger from "@/configs/logger";

@Component({ components: { PageHeader } })
export default class DIDs extends Vue {
  @Action("getDIDs") getDIDs!: Function;
  @Action("getLead") getLead!: Function;
  @Action("bindTaskAttributes") bindTaskAttributes!: Function;
  @Action("changeCallMode") changeCallMode!: Function;
  @State("user") user!: User;
  @Getter("availableStatus") available!: boolean;

  editableRowId: string = "";
  loading = false;
  didLoading = false;
  dialog = false;
  search = "";
  valid = false;
  items = [
    "vendor_transfer",
    "internal_transfer",
    "customer_inbound_call",
    "customer_service_inbound_call"
  ];
  dids = [];
  updatedValues: any = {};
  leadSource = "";
  bufferTime = "";
  taskCreationSource = "";
  requireDispositionNote = false;

  headers = [
    {
      text: "Phone Number",
      align: "start",
      sortable: true,
      value: "phone_number"
    },
    { text: "Lead Source", value: "lead_source" },
    { text: "Buffer Time (seconds)", value: "buffer_time_s" },
    { text: "Require Disposition Note", value: "require_disposition_note" },
    { text: "Skip dialing after call", value: "skip_dialer" },
    { text: "Requested Group", value: "requested_group" },
    { text: "Task Creation Source", value: "task_creation_source" },
    { text: "Edit", value: "edit" }
  ];

  mounted() {
    this.loadDIDs();
  }

  enableEdit(id: string) {
    if (this.editableRowId !== id) {
      this.editableRowId = id;
    } else {
      this.editableRowId = "";
    }
  }

  handleChange(id: string, key: string, val: any) {
    let value = val;
    if (key === "require_disposition_note" || key === "skip_dialer") {
      value = val === "Yes" ? true : false;
    }
    this.updatedValues[id] = { ...this.updatedValues[id], [key]: value };
  }

  async submitUpdate() {
    try {
      await Promise.all(
        Object.keys(this.updatedValues).map(key =>
          collections.dids.doc(key).update(this.updatedValues[key])
        )
      );
      await this.loadDIDs();
      this.editableRowId = "";
      this.$toasted.success("did updated").goAway(2000);
    } catch (err) {
      logger("error", "did update error", err);
      this.$toasted.error("DID update error");
    }
  }

  async handleCreateDID() {
    try {
      this.didLoading = true;
      const resp = await api.createDID(
        this.leadSource,
        this.bufferTime,
        this.taskCreationSource,
        this.requireDispositionNote
      );
      this.didLoading = false;
      await this.loadDIDs();
      logger("log", "Creating DID successful");
      this.$toasted.success(resp.data.phone_number).goAway(2000);
      this.dialog = false;
    } catch (err) {
      if (err.response.data.error) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.$toasted.error("Creating DID failed").goAway(2000);
      }
    }
    this.dialog = false;
  }
  async loadDIDs() {
    this.loading = true;
    this.dids = (await this.getDIDs()).map((item: any) => ({
      ...item,
      edit: "edit"
    }));
    logger("info", "DIDS:");
    logger("info", this.dids);
    this.loading = false;
  }
}
